import { GenericObject } from 'core/models/platform';
import wordLookUp from './wordLookupWiki';

/**
 * TODO ... this implementation will un-necessary increase load on the client side as it is loading up all objects and running transformations.
 * Take necessary steps to bring optimization here.
 */

class BasicContractions {
  private static instance: BasicContractions;

  contractions: GenericObject;

  expandLookup: GenericObject;

  contractLookup: GenericObject;

  expandRegex: RegExp;

  contractRegex: RegExp;

  constructor() {
    this.contractions = this.generateSpacedContractions();
    this.expandLookup = this.contractions;
    this.expandRegex = new RegExp(this.sortKeys(this.expandLookup).join('|'), 'gi');
    this.contractLookup = this.generateReverseLookups();
    this.contractRegex = new RegExp(this.sortKeys(this.contractLookup).join('|'), 'gi');
  }

  static getInstance(): BasicContractions {
    if (!BasicContractions.instance) BasicContractions.instance = new BasicContractions();
    return BasicContractions.instance;
  }

  sortKeys(obj: GenericObject) {
    const keys = Object.keys(obj);
    keys.sort((a, b) => {
      let diff = b.length - a.length;
      if (diff !== 0) {
        diff = (obj[b] as string).length - (obj[a] as string).length;
      }
      return diff;
    });

    return keys;
  }

  generateSpacedContractions() {
    const spacedContractions: GenericObject = {};
    Object.keys(wordLookUp).forEach((key) => {
      spacedContractions[`${key} `] = `${wordLookUp[key as keyof typeof wordLookUp]} `;
    });

    return spacedContractions;
  }

  generateReverseLookups() {
    const contractLookup: GenericObject = {};
    Object.keys(this.contractions).forEach((key) => {
      contractLookup[<any>(<unknown>this.contractions[key])] = key;
    });
    return contractLookup;
  }

  private convert(text: string, lookup: GenericObject, regexp: RegExp) {
    return text.replace(regexp, (matched) => {
      let replacement = <string>lookup[matched.toLowerCase()];
      const firstCharCode =
        matched.charAt(0) === "'" ? matched.charCodeAt(1) : matched.charCodeAt(0);

      // Check if first character of matched string is uppercase
      if (firstCharCode >= 65 && firstCharCode <= 90) {
        // Uppercase the first character of the replacement text
        if (replacement.charAt(0) === "'") {
          replacement = `'${replacement.charAt(1).toUpperCase()}${replacement.slice(2)}`;
        } else {
          replacement = replacement.charAt(0).toUpperCase() + replacement.slice(1);
        }
      }

      return replacement;
    });
  }

  expand(text: string) {
    return this.convert(text, this.expandLookup, this.expandRegex);
  }

  contract(text: string) {
    return this.convert(text, this.contractLookup, this.contractRegex);
  }
}

const contractionInstance = BasicContractions.getInstance();
export default contractionInstance;
